export default class stringHelper {
    static convertNumberOrUndefinedToString(numberToConvert: number | undefined) {
        return numberToConvert != undefined ? numberToConvert.toString() : "";
    }

    /**
     * Retire les accents et les majuscules d'une string
     * @param str
     * @returns
     */
    static normalizeString(str: string): string {
        return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
}



// WEBPACK FOOTER //
// ./src/Helper/stringHelper.ts